// src/context/brandVoice/widgets/ScalarEditor.jsx — the `scalar` editor (v189):
// messaging.positioning (required — the document's only required field), messaging.usp, messaging.uvp.
//
// ⭐ ONE growing box that soft-wraps; ⛔ no real line breaks — the backend collapses every
// whitespace run into one space (sheet 08, common rule 1), so Enter is blocked and a pasted
// newline becomes a space. ⛔ It validates nothing: `positioning`'s required check runs on save
// (`validateField`), and FieldRow already says "obbligatorio"; `problems` only sets
// `aria-invalid`. Its accessible name is the field's own label (the same key FieldRow uses).
// v200: a placeholder with an example (`fieldPlaceholder.js`; none for a field without one); the box grows to it.
import React from 'react';
import { useTranslation } from 'react-i18next';
import GrowingTextarea, { blockEnter, oneLine } from '../ui/GrowingTextarea.jsx';
import { INPUT } from './listStyles.js';
import { fieldPlaceholder } from './fieldPlaceholder.js';

export default function ScalarEditor({ field, value, onChange, disabled = false, problems = [] }) {
  const { t } = useTranslation('context');
  const path = field?.field_path || '';
  const invalid = (problems || []).length > 0;
  return (
    <GrowingTextarea
      aria-label={t(`brandVoice.fields.${path}`, { defaultValue: path })}
      aria-invalid={invalid || undefined}
      placeholder={fieldPlaceholder(t, { path })}
      fitPlaceholder
      value={typeof value === 'string' ? value : ''}
      disabled={disabled}
      onKeyDown={blockEnter}
      onChange={(e) => onChange?.(oneLine(e.target.value))}
      style={{ ...INPUT(invalid), width: '100%' }}
    />
  );
}
